// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dSNLA","top":"styles_top__1clR3"};